// This action exists as a way to track a Mixpanel event when something
// happens that doesn't involve any actions. In situations where an action
// is already being dispatched you can just augment the action with
// {meta: mixpanel: {...}}.
export const track = (eventName, props) => dispatch => {
  dispatch({
    type: 'MIXPANEL_TRACK',
    meta: {
      mixpanel: {
        eventName,
        props,

        // Makes the event's "action" appear as the formatted event name in
        // Mixpanel. This ensures the action won't be "Mixpanel Track", which
        // is just an implementation detail, hence trying to make it something
        // more useful here.
        type: eventName
      }
    }
  });
};
